import React from "react";
import { GiftIcon } from "lucide-react";
import { bonos } from "../data/salesContent";
export function Bonos() {
  return <section aria-labelledby="bonos" className="w-full bg-cream py-16 lg:py-24" data-id="element-12" data-mp="2hdcx3ygs0qys">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16" data-id="element-13" data-mp="2ldwvf5d360mi">
        <div className="lg:sticky lg:top-8 lg:self-start" data-id="element-14" data-mp="2q550jp7duztv">
          <p className="font-display text-sm font-extrabold uppercase tracking-widest text-gold-deep" data-id="element-15" data-mp="2q6pubclvieqo">
            Valor $75
          </p>
          <h2 id="bonos" className="mt-2 font-display text-3xl font-black text-ink sm:text-5xl" data-id="element-16" data-mp="3029o9tgvn3cs">
            5 bonos gratis
          </h2>
          <p className="mt-4 text-lg text-muted" data-id="element-17" data-mp="352xjkrc526ct">
            Las herramientas que convierten tus recetas en ventas, incluidas sin costo extra.
          </p>
          <div className="mt-8 rounded-2xl bg-ink p-6 text-cream" data-id="element-18" data-mp="1aowkq6gl9jcq">
            <p className="text-sm text-cream/70" data-id="element-19" data-mp="1epq910xy1065">Valor total bonos</p>
            <p className="mt-1 font-display text-3xl font-black" data-id="element-20" data-mp="1epzxul7951a9">
              <span className="text-cream/50 line-through decoration-2" data-id="element-21" data-mp="3e52l16e3r9ou">$75</span>{" "}
              <span className="text-gold" data-id="element-22" data-mp="39d11czelugos">GRATIS</span>
            </p>
            <p className="mt-1 text-sm text-cream/70" data-id="element-23" data-mp="34e7p1ab20vq7">con tu MegaPack</p>
          </div>
        </div>

        <ul className="space-y-4" data-id="element-24" data-mp="2zf4w2o8cmfyl">
          {bonos.map(b => <li key={b.number} className={`flex items-center gap-5 rounded-2xl border-l-[6px] ${b.border} bg-white p-5 sm:p-6`} data-id="element-25" data-mp="2zgy15z3bcs4h">
              <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-full ${b.accent}`} data-id="element-26" data-mp="3s4tsspe0ztue">
                <GiftIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-27" data-mp="3n34hr9qszg6b" />
              </span>
              <div className="min-w-0 flex-1" data-id="element-28" data-mp="3i530mucxtqxh">
                <p className="font-display text-xs font-extrabold uppercase tracking-wider text-muted" data-id="element-29" data-mp="2bpaho28dsjc8">
                  Bono {b.number}
                </p>
                <h3 className="font-display text-lg font-extrabold leading-snug text-ink" data-id="element-30" data-mp="26owb6omfhhgb">{b.title}</h3>
              </div>
              <div className="shrink-0 text-right" data-id="element-31" data-mp="yp5x5mryq8ku">
                <p className="text-sm text-muted line-through" data-id="element-32" data-mp="12rkg06vmt8c4">$15</p>
                <p className="font-display text-base font-black text-gold-deep" data-id="element-33" data-mp="ot2t2bdjvzv9">GRATIS</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}